import { useContext } from "react";
import { BsFileEarmarkExcel } from "react-icons/bs";
import { ButtonLoading } from "../../../components/button/Button";
import { Table } from "../../../components/table/Table";
import { FeatureContext } from "../../../Context";
import { lang } from "../../../Utils";
import { downloadOrderDetails } from "../Services";

const HandlingUnit = () => {
  const context = useContext(FeatureContext);

  return (<div>
    <div className="bf-actions bf-mb-10">
      <ButtonLoading
        disabled={!context?.details}
        callback={downloadOrderDetails}
        args={{ 
          orderId: context?.details?.slice(0, 1)[0]?.salesOrderNumber, 
          deliveryItem : context?.delivery?.deliveryItem, 
          salesOrderItem : context?.delivery?.salesOrderItem, 
          section: 'handlingUnit' 
        }}
        icon={<BsFileEarmarkExcel />}
        label={lang('Excel')} />
    </div>
    <Table dataSet={context?.delivery?.handlingUnit} pagination={true} hover={false}>
      <Table.Caption>{lang('Handling Unit')}</Table.Caption>
      <Table.Header>
        <Table.Header.Column sortKey={"delivery"} sortable={true}>{lang('Qty')}</Table.Header.Column>
        <Table.Header.Column sortKey={"quantityDelivered"} sortable={true}>{lang('Net Weight')}</Table.Header.Column>
        <Table.Header.Column sortKey={"goodsMovementDate"} sortable={true}>{lang('Loading Weight')}</Table.Header.Column>
        <Table.Header.Column sortKey={"incoterm"} sortable={true}>{lang('Total Weight')}</Table.Header.Column>
        <Table.Header.Column sortKey={"salesUnit"} sortable={true}>{lang('Close/Open Packaging')}</Table.Header.Column>
        <Table.Header.Column sortKey={"trackingNumber"} sortable={true}>{lang('HU Description')}</Table.Header.Column>
        <Table.Header.Column sortKey={"itemQuantity"} sortable={true}>{lang('HU Qty')}</Table.Header.Column>
      </Table.Header>
      <Table.Body noDataMessage={lang('No Data available to display')}>
        <Table.Body.Text label={lang('Qty')} field="deliveryItemQuantity" />
        <Table.Body.Text label={lang('Net Weight')} field="netWeight" />
        <Table.Body.Text label={lang('Loading Weight')} field="loadingWeight" />
        <Table.Body.Text label={lang('Total Weight')} field="totalWeight" />
        <Table.Body.Boolean label={lang('Close/Open Packaging')} field="isOpen" istrue={lang('Open')} isfalse={lang('Close')} />
        <Table.Body.Text label={lang('HU Description')} field="description" />
        <Table.Body.Text label={lang('HU Qty')} field="itemQuantity" />
      </Table.Body>
    </Table>
  </div>)
}

export default HandlingUnit;